import React from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { menuMobileShow } from '../../redux/actions/userActions';

import { removeSpecialChar } from '../../helperFunctions'
import { useTranslation } from 'react-i18next';

const CategorySidebarVirtualItems = ({ item, key, setMenuItem }) => {

    const dispatch = useDispatch();
    const isDesktop = window.innerWidth > 1020;
    const { t } = useTranslation('routes');

    const setMobileFunction = () => {
        dispatch(menuMobileShow(false));
        if (!isDesktop) {
            setMenuItem(false)
        }
    }

    const setDeafultFilters = () => {
        dispatch({
            type: 'SET_FINISHED_FILTERS',
            payload: false
        });
        dispatch({
            type: 'SET_DEFAULT_URL_FILTERS',
            payload: {
                url: item.acUrl.split("?")[1],
                name: item.acName
            }
        });
        setMobileFunction()
    }

    return (
        <>
            {item.acUrl.includes("/" + t('pretraga')) ? (
                <Link to={item.acUrl} onClick={setMobileFunction}>
                    <li key={key}>{item.acName}</li>
                </Link>
            ) : (
                <Link to={`${item.acUrl.split("?")[0]}/${removeSpecialChar(item.acName)}`} onClick={setDeafultFilters}>
                    <li key={key}>{item.acName}</li>
                </Link>
            )
            }
        </>
    )
}

export default CategorySidebarVirtualItems